import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import styles from './BannerFaq/Faq.module.scss';

function CategoriesPopup({ setShowMore, categories, showAddDeleteKeywordsBtn, projectId }) {
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const navigate = useNavigate();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const categoriesPopupRef = useRef(null);

  const handleCloseFeedbackPopup = () => {
    setShowMore(false);
  };
  const handlePopupBtnClick = () => {
    const parentid = projectId === 'csportal' ? selectedBusiness?.parentid : selectedBusinessGenio?.parentId;
    const city = projectId === 'csportal' ? selectedBusiness?.data_city : selectedBusinessGenio?.city;
    navigate(`/${projectId}/create_ticket?parentId=${parentid}&city=${city}&key=Banner-JDRR&vertical= ''`);
  };
  useClickAwayListener(categoriesPopupRef, () => {
    handleCloseFeedbackPopup();
  });
  return (
    <section className="cs_modal_feedback undefined">
      <div ref={categoriesPopupRef} className="cs_modal_feedback_content cs_modal_animation fadeInUpTop">
        <div className="cs_modal_body p-10">
          <div className="cs_modal_feedback_close mt-10">
            <div style={{ textAlign: 'center', width: '100%' }} className="font12 fw600 color111">
              Categories
              <div
                className="modal_close csicon"
                onClick={() => handleCloseFeedbackPopup()}
                aria-label="categories close modal"
                type="button"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
              />
            </div>
          </div>
          <div className="FeedbackModal_FeedbackModal__Box__BAgpO">
            {categories && categories?.length > 0 && (
              <>
                <div
                  style={{ height: '350px', overflowY: 'scroll' }}
                  className={`${styles.CategoryListGroup} p-8 m-10`}
                >
                  {categories.map((item, i) => (
                    <div
                      style={{ textAlign: 'start' }}
                      key={i}
                      className={`${styles.CategoryListItem} font12 fw400 color111 mt-5 mb-5`}
                    >
                      {`${i + 1}. ${item || ''}`}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          {showAddDeleteKeywordsBtn && (
            <div>
              <button
                onClick={() => handlePopupBtnClick()}
                className={`${styles.Popup__Btn} ${styles.bluefill_animate} font10 fw500 mt-10`}
                type="button"
              >
                Want to delete or add keywords?
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default CategoriesPopup;

CategoriesPopup.propTypes = {
  setShowMore: PropTypes.func,
  categories: PropTypes.array,
  showAddDeleteKeywordsBtn: PropTypes.bool,
  projectId: PropTypes.string,
};
